export enum KooperationsPartner {
  SCHULE = 'Schule',
  CHANCENSCHULE = 'ChancenSCHULE',
  OEFFENTLICHE_STELLE = 'Öffentliche Stelle',
  GOVERNMENT_OFFICE = 'Amt',
  FOUNDATION = 'Stiftung',
  OFFICE = 'Bürostandort',

  NON_PROFIT_ORANISATION = 'gemeinnützige Organisation',
  ORGANISATION = 'Organisation',
  CLUB = 'Verein',
  UNIVERSITY = 'Universität/Hochschule',
  SUB_DIVISON = 'untergeordnete Kooperationspartnereinheit',
  MEDIA_COMPANY = 'Medienunternehmen',
  POLITIC = 'Politik',
  INSTITUTION = 'Institution',
  INSTITUTE = 'Institut',
  CHANCELLERY = 'Kanzlei',
  BANK = 'Bank',
  MESSE = 'Messeanbieter',
}

export function getPartnerClassString(value: string): string | undefined {
  const invertedMap: { [key: string]: string } = {};
  for (const key in PartnerClassMap) {
    if (Object.prototype.hasOwnProperty.call(PartnerClassMap, key)) {
      invertedMap[PartnerClassMap[key]] = key;
    }
  }
  return invertedMap[value];
}

export const PartnerClassMap = {
  Schule: 'School',
  ChancenSCHULE: 'ChancenSchule',
  'Öffentliche Stelle': 'PublicPlace',
  Amt: 'GovernmentOffice',
  Stiftung: 'Foundation',
  Bürostandort: 'OfficePartner',
  'gemeinnützige Organisation': 'NonProfitOrganisation',
  Organisation: 'Organisation',
  Verein: 'Club',
  'Universität/Hochschule': 'University',
  Medienunternehmen: 'MediaCompany',
  Politik: 'Politic',
  Institution: 'Institution',
  Institut: 'Institute',
  Kanzlei: 'Chancellery',
  Bank: 'Bank',
  'untergeordnete Kooperationspartnereinheit': 'SubDivision',
  Messeanbieter: 'Messe',
};

export enum KooperationsPartnerClass {
  SCHULE = 'School',
  CHANCENSCHULE = 'ChancenSchule',
  OEFFENTLICHE_STELLE = 'PublicPlace',
  GOVERNMENT_OFFICE = 'GovernmentOffice',
  FOUNDATION = 'Foundation',
  OFFICE = 'OfficePartner',
  NON_PROFIT_ORANISATION = 'NonProfitOrganisation',
  ORGANISATION = 'Organisation',
  CLUB = 'Club',
  UNIVERSITY = 'University',
  MEDIA_COMPANY = 'MediaCompany',
  POLITIC = 'Politic',
  INSTITUTION = 'Institution',
  INSTITUTE = 'Institute',
  CHANCELLERY = 'Chancellery',
  BANK = 'Bank',
  SUB_DIVISON = 'SubDivision',
  MESSE = 'Messe',
}
